import { TranslationRepository } from '../data/translation-repository';
import { ApplicationType, ExportResponse } from '../types/translation-types';

export class ExportTranslationsUseCase {
  constructor(private readonly repository: TranslationRepository) {}

  async execute(applicationType: ApplicationType): Promise<ExportResponse> {
    return this.repository.exportTranslations(applicationType);
  }
}
